"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _userProfile = require("user-profile");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _noty = require("noty");

var _commentForm = babelHelpers.interopRequireDefault(require("./comment-form"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _animationHelper = babelHelpers.interopRequireDefault(require("animation-helper"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _momentTimezone = babelHelpers.interopRequireDefault(require("moment-timezone"));

var _ProfileImageContainer = babelHelpers.interopRequireDefault(require("components/ProfileImageContainer"));

var _class, _class2, _descriptor, _temp, _class4, _descriptor2, _descriptor3, _descriptor4, _temp2, _class6, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _temp3;

var Dropdown = (_class =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(Dropdown, _Component);

  function Dropdown() {
    babelHelpers.classCallCheck(this, Dropdown);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Dropdown).apply(this, arguments));
  }

  babelHelpers.createClass(Dropdown, [{
    key: "setValue",
    value: function setValue(event) {
      this.props.setValue(this.props.id, event.target.value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          text = _this$props.text,
          required = _this$props.required,
          options = _this$props.options,
          disabled = _this$props.disabled;
      return _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("select", {
        className: "form-control",
        name: id,
        id: "question_".concat(id),
        onChange: this.setValue,
        value: this.props.value,
        disabled: disabled
      }, options.map(function (_ref) {
        var _ref2 = babelHelpers.slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        return _react.default.createElement("option", {
          key: key,
          value: key
        }, value);
      })), _react.default.createElement("span", null));
    }
  }]);
  return Dropdown;
}(_react.Component), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "setValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setValue"), _class.prototype)), _class);
var TimeZoneSelect = (_class2 = (_temp =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(TimeZoneSelect, _Component2);

  function TimeZoneSelect() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, TimeZoneSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(TimeZoneSelect)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "currentTime", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this._zoneData = {};
    _this._zoneCache = {};
    return _this;
  }

  babelHelpers.createClass(TimeZoneSelect, [{
    key: "render",
    value: function render() {
      if (!this._zoneData[this.currentTime]) {
        var m = (0, _momentTimezone.default)(this.currentTime);
        var zl = Object.keys(ZoneList).map(function (name) {
          return [Number(m.tz(ZoneList[name]).format('ZZ')), ZoneList[name], "(GMT".concat(m.tz(ZoneList[name]).format('Z'), ") ").concat(name)];
        });
        zl.sort(function (left, right) {
          return left[0] - right[0];
        });
        zl = zl.map(function (_ref3) {
          var _ref4 = babelHelpers.slicedToArray(_ref3, 3),
              x = _ref4[0],
              a = _ref4[1],
              b = _ref4[2];

          return [a, b];
        });
        var k = JSON.stringify(zl);
        if (this._zoneCache[k]) zl = this._zoneCache[k];
        this._zoneData[this.currentTime] = zl;
      }

      return _react.default.createElement(Dropdown, {
        id: this.props.id,
        text: this.props.text,
        setValue: this.props.setValue,
        required: this.props.required,
        options: this._zoneData[this.currentTime],
        disabled: this.props.disabled,
        value: this.props.value
      });
    }
  }]);
  return TimeZoneSelect;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class2.prototype, "currentTime", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2);
var ZoneList = {
  "Pago Pago": "Pacific/Pago_Pago",
  "Hawaii Time": "Pacific/Honolulu",
  "Pacific Time": "America/Los_Angeles",
  "Pacific Time - Tijuana": "America/Tijuana",
  "Mountain Time": "America/Denver",
  "Mountain Time - Arizona": "America/Phoenix",
  "Mountain Time - Chihuahua, Mazatlan": "America/Mazatlan",
  "Central Time": "America/Chicago",
  "Central Time - Mexico City": "America/Mexico_City",
  "Central Time - Regina": "America/Regina",
  "Guatemala": "America/Guatemala",
  "Bogota": "America/Bogota",
  "Eastern Time": "America/New_York",
  "Lima": "America/Lima",
  "Caracas": "America/Caracas",
  "Atlantic Time - Halifax": "America/Halifax",
  "Guyana": "America/Guyana",
  "La Paz": "America/La_Paz",
  "Buenos Aires": "America/Argentina/Buenos_Aires",
  "Godthab": "America/Godthab",
  "Montevideo": "America/Montevideo",
  "Newfoundland Time - St. Johns": "America/St_Johns",
  "Santiago": "America/Santiago",
  "Sao Paulo": "America/Sao_Paulo",
  "South Georgia": "Atlantic/South_Georgia",
  "Azores": "Atlantic/Azores",
  "Cape Verde": "Atlantic/Cape_Verde",
  "Casablanca": "Africa/Casablanca",
  "Dublin": "Europe/Dublin",
  "Lisbon": "Europe/Lisbon",
  "London": "Europe/London",
  "Monrovia": "Africa/Monrovia",
  "Algiers": "Africa/Algiers",
  "Amsterdam": "Europe/Amsterdam",
  "Berlin": "Europe/Berlin",
  "Brussels": "Europe/Brussels",
  "Budapest": "Europe/Budapest",
  "Central European Time - Belgrade": "Europe/Belgrade",
  "Central European Time - Prague": "Europe/Prague",
  "Copenhagen": "Europe/Copenhagen",
  "Madrid": "Europe/Madrid",
  "Paris": "Europe/Paris",
  "Rome": "Europe/Rome",
  "Stockholm": "Europe/Stockholm",
  "Vienna": "Europe/Vienna",
  "Warsaw": "Europe/Warsaw",
  "Athens": "Europe/Athens",
  "Bucharest": "Europe/Bucharest",
  "Cairo": "Africa/Cairo",
  "Jerusalem": "Asia/Jerusalem",
  "Johannesburg": "Africa/Johannesburg",
  "Helsinki": "Europe/Helsinki",
  "Kiev": "Europe/Kiev",
  "Moscow-01 - Kaliningrad": "Europe/Kaliningrad",
  "Riga": "Europe/Riga",
  "Sofia": "Europe/Sofia",
  "Tallinn": "Europe/Tallinn",
  "Vilnius": "Europe/Vilnius",
  "Istanbul": "Europe/Istanbul",
  "Baghdad": "Asia/Baghdad",
  "Nairobi": "Africa/Nairobi",
  "Minsk": "Europe/Minsk",
  "Riyadh": "Asia/Riyadh",
  "Moscow+00 - Moscow": "Europe/Moscow",
  "Tehran": "Asia/Tehran",
  "Baku": "Asia/Baku",
  "Moscow+01 - Samara": "Europe/Samara",
  "Tbilisi": "Asia/Tbilisi",
  "Yerevan": "Asia/Yerevan",
  "Kabul": "Asia/Kabul",
  "Karachi": "Asia/Karachi",
  "Moscow+02 - Yekaterinburg": "Asia/Yekaterinburg",
  "Tashkent": "Asia/Tashkent",
  "Colombo": "Asia/Colombo",
  "Almaty": "Asia/Almaty",
  "Dhaka": "Asia/Dhaka",
  "Rangoon": "Asia/Rangoon",
  "Bangkok": "Asia/Bangkok",
  "Jakarta": "Asia/Jakarta",
  "Moscow+04 - Krasnoyarsk": "Asia/Krasnoyarsk",
  "China Time - Beijing": "Asia/Shanghai",
  "Hong Kong": "Asia/Hong_Kong",
  "Kuala Lumpur": "Asia/Kuala_Lumpur",
  "Moscow+05 - Irkutsk": "Asia/Irkutsk",
  "Singapore": "Asia/Singapore",
  "Taipei": "Asia/Taipei",
  "Ulaanbaatar": "Asia/Ulaanbaatar",
  "Western Time - Perth": "Australia/Perth",
  "Moscow+06 - Yakutsk": "Asia/Yakutsk",
  "Seoul": "Asia/Seoul",
  "Tokyo": "Asia/Tokyo",
  "Central Time - Darwin": "Australia/Darwin",
  "Eastern Time - Brisbane": "Australia/Brisbane",
  "Guam": "Pacific/Guam",
  "Moscow+07 - Magadan": "Asia/Magadan",
  "Moscow+07 - Yuzhno-Sakhalinsk": "Asia/Vladivostok",
  "Port Moresby": "Pacific/Port_Moresby",
  "Central Time - Adelaide": "Australia/Adelaide",
  "Eastern Time - Hobart": "Australia/Hobart",
  "Eastern Time - Melbourne, Sydney": "Australia/Sydney",
  "Guadalcanal": "Pacific/Guadalcanal",
  "Noumea": "Pacific/Noumea",
  "Majuro": "Pacific/Majuro",
  "Moscow+09 - Petropavlovsk-Kamchatskiy": "Asia/Kamchatka",
  "Auckland": "Pacific/Auckland",
  "Fakaofo": "Pacific/Fakaofo",
  "Fiji": "Pacific/Fiji",
  "Tongatapu": "Pacific/Tongatapu",
  "Apia": "Pacific/Apia"
};
var EventScheduleCheck = (_class4 = (_temp2 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(EventScheduleCheck, _Component3);

  function EventScheduleCheck() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, EventScheduleCheck);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(EventScheduleCheck)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "value", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "values", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "onChange", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    return _this2;
  }

  babelHelpers.createClass(EventScheduleCheck, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: "check-wrap"
      }, _react.default.createElement("input", {
        type: "checkbox",
        onChange: this.didChange,
        checked: this.values.indexOf(this.value) != -1,
        name: this.value
      }), _react.default.createElement("span", null));
    }
  }, {
    key: "didChange",
    value: function didChange(event) {
      this.onChange(event.target.name, event.target.checked);
    }
  }]);
  return EventScheduleCheck;
}(_react.Component), _temp2), (_descriptor2 = babelHelpers.applyDecoratedDescriptor(_class4.prototype, "value", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class4.prototype, "values", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class4.prototype, "onChange", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class4.prototype, "didChange", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class4.prototype, "didChange"), _class4.prototype)), _class4);
var EventScheduleRootNode = (_class6 = (_temp3 =
/*#__PURE__*/
function (_Component4) {
  babelHelpers.inherits(EventScheduleRootNode, _Component4);

  function EventScheduleRootNode() {
    var _babelHelpers$getProt3;

    var _this3;

    babelHelpers.classCallCheck(this, EventScheduleRootNode);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(EventScheduleRootNode)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this3, "discussionRoot", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "commentPosted", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "discussion", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    babelHelpers.initializerDefineProperty(_this3, "trackData", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this3)));
    _this3.componentIsMounted = false;
    _this3.state = {
      submitting: false,
      userProfile: null,
      scheduledValues: [],
      timezone: _momentTimezone.default.tz.guess()
    };
    return _this3;
  }

  babelHelpers.createClass(EventScheduleRootNode, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;

      this.componentIsMounted = true;
      (0, _userProfile.getUserProfile)().then(function (profile) {
        _this4.setState({
          userProfile: profile
        });
      });
      $(document).on('profileUpdated', this.profileUpdated);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.componentIsMounted = false;
      $(document).off('profileUpdated', this.profileUpdated);

      if (this.state.showUploadInstructions) {
        document.documentElement.removeEventListener('click', this.hideUploadInstructions);
      }
    }
  }, {
    key: "profileUpdated",
    value: function profileUpdated(event) {
      this.setState({
        userProfile: event.profile
      });
    }
  }, {
    key: "setUploadCallback",
    value: function setUploadCallback(callback) {
      this.setState({
        documentUploadCallback: callback
      });
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.setState(function (st) {
        return {
          document: null,
          documentUploadCallback: null,
          showUploadInstructions: false,
          generation: st.generation + 1
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      if (!this.state.userProfile) return null;
      if (this.discussion.children.length) return null;
      return _react.default.createElement("div", {
        className: "comment-thread"
      }, _react.default.createElement("article", {
        className: "comment-item event-schedule-item"
      }, _react.default.createElement("header", null, _react.default.createElement("div", {
        className: "photo"
      }, _react.default.createElement(_ProfileImageContainer.default, {
        componentName: "div",
        className: "userProfilePhoto",
        noImageClassName: "default",
        photo: this.state.userProfile.photo,
        name: this.state.userProfile.nickname || this.state.userProfile.fullName || ""
      })), _react.default.createElement("div", {
        className: "info-block"
      }, _react.default.createElement("div", {
        className: "person"
      }, _react.default.createElement("span", {
        className: "person-name"
      }, this.state.userProfile.nickname || this.state.userProfile.fullName || 'System')))), _react.default.createElement(_commentForm.default, {
        hidden: false,
        canSubmit: this.state.scheduledValues.length > 0,
        submitComment: this.submitComment,
        userProfile: this.state.userProfile,
        submitting: this.state.submitting,
        placeholder: "Add a comment...",
        acceptEmptyComment: true,
        submitButtonText: "Submit"
      }, _react.default.createElement("div", null, _react.default.createElement("p", null, "This event is not yet scheduled.", _react.default.createElement("br", null), "Use the form below to let us know your day and time preferences."), _react.default.createElement("h2", null, "What days and times work best for you?"), _react.default.createElement("table", null, _react.default.createElement("thead", null, _react.default.createElement("tr", null, _react.default.createElement("td", null), _react.default.createElement("th", {
        scope: "col"
      }, "Sun"), _react.default.createElement("th", {
        scope: "col"
      }, "Mon"), _react.default.createElement("th", {
        scope: "col"
      }, "Tue"), _react.default.createElement("th", {
        scope: "col"
      }, "Wed"), _react.default.createElement("th", {
        scope: "col"
      }, "Thu"), _react.default.createElement("th", {
        scope: "col"
      }, "Fri"), _react.default.createElement("th", {
        scope: "col"
      }, "Sat"))), _react.default.createElement("tbody", null, [['Morning', 'Before noon'], ['Afternoon', '12-5pm'], ['Evening', 'After 5pm']].map(function (_ref5) {
        var _ref6 = babelHelpers.slicedToArray(_ref5, 2),
            hdr = _ref6[0],
            subTitle = _ref6[1];

        return _react.default.createElement("tr", {
          key: hdr
        }, _react.default.createElement("th", {
          scope: "row"
        }, hdr, _react.default.createElement("br", null), _react.default.createElement("small", null, subTitle)), ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(function (day) {
          return _react.default.createElement("td", {
            key: day
          }, _react.default.createElement(EventScheduleCheck, {
            value: "".concat(day).concat(hdr),
            values: _this5.state.scheduledValues,
            onChange: _this5.toggleSchedule
          }));
        }));
      })))), _react.default.createElement("div", null, _react.default.createElement("h2", null, "What is your timezone?"), _react.default.createElement(TimeZoneSelect, {
        id: "timeZone",
        currentTime: Date.now(),
        value: this.state.timezone,
        setValue: this.setTimezone,
        disabled: this.state.submitting
      })), _react.default.createElement("div", null, _react.default.createElement("h2", null, "Comments")))));
    }
  }, {
    key: "setTimezone",
    value: function setTimezone(_, value) {
      this.setState({
        timezone: value
      });
    }
  }, {
    key: "toggleSchedule",
    value: function toggleSchedule(id, value) {
      this.setState(function (_ref7) {
        var scheduledValues = _ref7.scheduledValues;
        return {
          scheduledValues: scheduledValues.slice().filter(function (v) {
            return v != id;
          }).concat(value ? [id] : [])
        };
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.showUploadInstructions != this.state.showUploadInstructions) {
        if (this.state.showUploadInstructions) document.documentElement.addEventListener('click', this.hideUploadInstructions);else document.documentElement.removeEventListener('click', this.hideUploadInstructions);
      }
    }
  }, {
    key: "doPostComment",
    value: function doPostComment(comment) {
      return (0, _fetch.default)('data/discussion/post', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(this.getCommentBody(comment))
      }).then(function (result) {
        if (result.ok) return result.status == 204 ? true : result.json();
        return result.json().then(function (value) {
          throw value;
        });
      });
    }
  }, {
    key: "getCommentBody",
    value: function getCommentBody(comment) {
      var _this$state = this.state,
          scheduledValues = _this$state.scheduledValues,
          timezone = _this$state.timezone;
      return {
        child_type: 'eventScheduleRequest',
        parent: this.discussionRoot.id,
        comment: comment,
        timeZone: timezone,
        schedule: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].reduce(function (acc, value) {
          return Object.assign(acc, babelHelpers.defineProperty({}, value.toLowerCase(), ['Morning', 'Afternoon', 'Evening'].reduce(function (acc, timeValue) {
            return Object.assign(acc, babelHelpers.defineProperty({}, timeValue.toLowerCase(), scheduledValues.indexOf("".concat(value).concat(timeValue)) != -1));
          }, {})));
        }, {})
      };
    }
  }, {
    key: "submitComment",
    value: function submitComment(comment) {
      var _this6 = this;

      return new _promisePolyfill.default(function (resolve, reject) {
        _this6.setState({
          submitting: true
        }, function () {
          _this6.doPostComment(comment).then(function (result) {
            (0, _noty.showNotificationText)('Your scheduling request has been made.');

            _this6.commentPosted();

            if (_this6.componentIsMounted) {
              _this6.setState({
                submitting: false
              });
            }

            resolve(true);
          }).catch(function (error) {
            if (_this6.componentIsMounted) {
              _this6.setState({
                submitting: false
              });
            }

            ;
            reject(error);
          });
        });
      });
    }
  }]);
  return EventScheduleRootNode;
}(_react.Component), _temp3), (_descriptor5 = babelHelpers.applyDecoratedDescriptor(_class6.prototype, "discussionRoot", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class6.prototype, "commentPosted", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class6.prototype, "discussion", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class6.prototype, "trackData", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class6.prototype, "profileUpdated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class6.prototype, "profileUpdated"), _class6.prototype), babelHelpers.applyDecoratedDescriptor(_class6.prototype, "setUploadCallback", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class6.prototype, "setUploadCallback"), _class6.prototype), babelHelpers.applyDecoratedDescriptor(_class6.prototype, "cancel", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class6.prototype, "cancel"), _class6.prototype), babelHelpers.applyDecoratedDescriptor(_class6.prototype, "setTimezone", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class6.prototype, "setTimezone"), _class6.prototype), babelHelpers.applyDecoratedDescriptor(_class6.prototype, "toggleSchedule", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class6.prototype, "toggleSchedule"), _class6.prototype), babelHelpers.applyDecoratedDescriptor(_class6.prototype, "submitComment", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class6.prototype, "submitComment"), _class6.prototype)), _class6);
exports.default = EventScheduleRootNode;